import IndexHandler from './components/BillingIndexHandler'
export default IndexHandler
